export const featuresConfig = {
  dynamicHeight: {
    sectionIndex: 3,
    active: true,
  },
};
